import { Component, Input } from '@angular/core';

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.sass']
})
export class LoadingSpinnerComponent {

  @Input() text;
  
  constructor() { }


}



// WEBPACK FOOTER //
// ./src/app/shared/loading-spinner/loading-spinner.component.ts